import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import whatsapp from "../../Images/icons/whatsapp.webp";
import { Link } from "react-router-dom";
import facebook from "../../Images/icons/facebook.webp";
import twitter from "../../Images/icons/twitter.webp";
import instagram from "../../Images/icons/instagram.webp";
import linkedin from "../../Images/icons/linkedin.webp";
import youtube from "../../Images/icons/youtube.webp";
import logoWhite from "../../Images/logo/isbm-university-white.webp";
import EnquiryNow from "./EnquiryNow";

const Footer = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi"
        );
        setSchools(response.data.data);
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <a href="https://api.whatsapp.com/send/?phone=%2B919373199999&text&type=phone_number&app_absent=0" target="_blank">
        <img alt="whatsapp" id="whatsappp" src={whatsapp} />
      </a>
      <div className="desktop-btn">
        <button
          onClick={() => setModalShow(true)}
          className="trigger_popup border-0"
        >
          <span>Enquire Now</span>
        </button>
        <button
          onClick={() => setModalShow(true)}
          className="trigger_popup broucher border-0"
        >
          <span>Download Brochure</span>
        </button>
      </div>
      <EnquiryNow show={modalShow} onHide={() => setModalShow(false)} />

      <div className="footer-section">
        <div className="container-xxl">
          <Row className="flex-wrap-reverse m-0">
            {/* Column 1: About Us */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">About Us</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/about-us" target="_blank">About ISBM University </Link>
                </li>
                <li>
                  <Link to="/vision-mission" target="_blank">Vision and Mission</Link>
                </li>
                <li>
                  <Link to="/honorable-visitor" target="_blank">Hon'ble Visitor</Link>
                </li>
                <li>
                  <Link to="/honorable-patron" target="_blank">Hon'ble Patron</Link>
                </li>
                <li>
                  <Link to="/honorable-chancellor" target="_blank">Hon'ble Chancellor</Link>
                </li>

                <li>
                  <Link to="/honorable-vice-chancellor" target="_blank">
                    Hon'ble Vice-Chancellor
                  </Link>
                </li>
                <li>
                  <Link to="/official-registar" target="_blank">Registrar</Link>
                </li>

                <li>
                  <Link to="/governing-body" target="_blank">Governing Body</Link>
                </li>
                <li>
                  <Link to="/board-management" target="_blank">Board of Management</Link>
                </li>
                <li>
                  <Link to="/academic-council" target="_blank">Academic Council</Link>
                </li>
                <li>
                  <Link to="/board-advisor" target="_blank">Board of Advisors</Link>
                </li>
                <li>
                  <Link to="/other-communitie" target="_blank">Other Committees</Link>
                </li>
                <li>
                  <Link to="/dignitaries-messages" target="_blank">Messages of the Dignitaries</Link>
                </li>
                <li>
                  <Link to="/statues-and-ordinance" target="_blank">
                    Statutes and Ordinances
                  </Link>
                </li>
                <li>
                  <Link to="/accreditation-and-recognitions" target="_blank">
                    Accreditations and Recognitions
                  </Link>
                </li>
                <li>
                  <Link to="/awards" target="_blank">Awards</Link>
                </li>
                <li>
                  <Link to="/media-coverage" target="_blank">Media Coverage</Link>
                </li>
                <li>
                  <Link to="/RTI" target="_blank">RTI</Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-faculty" target="_blank">
                    Code of Conduct (Faculty)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-management" target="_blank">
                    Code of Conduct (Management)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-student" target="_blank">
                    Code of Conduct (Student)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-boardes-of-hostel" target="_blank">
                    Code of Conduct (Boardes of Hostel)
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Column 2: Schools */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">Our Schools</h4>
              <div className="schools-grid">
                {schools.map((school) => (
                  <div key={school.id} className="school-item">
                    <Link to={`/school-details/${school.name}`} target="/">
                      {school.title}
                    </Link>
                  </div>
                ))}
              </div>
            </Col>

            {/* Column 3: Admissions & Academics */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">Admissions</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/programmes-and-eligibilities" target="_blank">
                    Programmes and Eligibilities
                  </Link>
                </li>
                <li>
                  <Link to="/programmes-by-qualification" target="_blank">
                    Programmes By Qualification
                  </Link>
                </li>
                <li>
                  <Link to="/apply-online" target="_blank">Apply Online</Link>
                </li>
                <li>
                  <Link to="/admission-procedure-guidelines" target="_blank">
                    Admission Procedure
                  </Link>
                </li>
                <li>
                  <Link to="/pay-fees-online" target="_blank">Online Payment</Link>
                </li>
                <li>
                  <Link to="/admission-help-desk" target="_blank">Admission Helpdesk</Link>
                </li>
              </ul>

              <h4 className="footer-heading mt-4" target="_blank">Academics</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/academic-philosophy" target="_blank">Academic Philosophy</Link>
                </li>
                <li>
                  <Link to="/academic-partner" target="_blank">Academic Partners</Link>
                </li>
                <li>
                  <Link to="/teaching-methodology-pedagogy" target="_blank">
                    Teaching Methodology
                  </Link>
                </li>
                <li>
                  <Link to="/mooc-with-isbm" target="_blank">MOOC with ISBM</Link>
                </li>
                <li>
                  <Link to="/research" target="_blank">Research</Link>
                </li>
                <li>
                  <Link to="/blog" target="_blank">Blogs</Link>
                </li>
              </ul>
            </Col>

            {/* Column 4: Logo, Address, Map & Social */}
            <Col md={3} className="footer-contact-column">
              <div className="footer-logo-wrapper">
                <img
                  src={logoWhite}
                  alt="ISBM University Logo"
                  className="footer-logo"
                />
              </div>
              <h5>ISBM University Campus</h5>
              <div className="footer-address">
                Nawapara (Kosmi)
                <br />
                Block & Tehsil- Chhura, Gariyaband,
                <br />
                Chhattisgarh-493996, India
              </div>

              <div className="footer-map" style={{ maxWidth: "250px" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4049.1388814933766!2d82.27918607519366!3d20.843678994109872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a25febf2368cb33%3A0x8df9cf351c0cd8d5!2sISBM%20University!5e1!3m2!1sen!2sin!4v1752229578743!5m2!1sen!2sin"
                  width="100%"
                  height="150"
                  allowFullScreen=""
                  loading="lazy"
                  title="ISBM University Location"
                ></iframe>
              </div>

              <h5>ISBM University Raipur Campus</h5>
              <div className="footer-address">
                ISBM University,
                <br />
                Ring Road No. 1, Near Sarona Bridge,
                <br />
                Tatibandh, Raipur, Chhattisgarh-492099
              </div>

              <div className="footer-map" style={{ maxWidth: "250px" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.027093211917!2d81.6549554!3d21.239416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd0206b8f86b%3A0x9040865570943ee2!2sISBM%20University!5e1!3m2!1sen!2sin!4v1691149200202!5m2!1sen!2sin"
                  width="100%"
                  height="150"
                  style={{ border: 0 }}
                  allowFullScreen={false}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="ISBM University Location"
                />
              </div>

              <div className="footer-social-icons">
                <div className="social-icons-grid">
                  <a
                    href="https://www.facebook.com/isbmuniversity/"
                    target="_blank"
                    aria-label="Facebook"
                    className="social-icon"
                  >
                    <img src={facebook} alt="Facebook" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a
                    href="https://instagram.com/isbm_university"
                    target="_blank"
                    aria-label="Instagram"
                    className="social-icon"
                  >
                    <img src={instagram} alt="Instagram" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a
                    href="https://twitter.com/ISBMUniversity"
                    target="_blank"
                    aria-label="Twitter"
                    className="social-icon"
                  >
                    <img src={twitter} alt="Twitter" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a
                    href="https://www.linkedin.com/school/13211303/admin/"
                    target="_blank"
                    aria-label="LinkedIn"
                    className="social-icon"
                  >
                    <img src={linkedin} alt="LinkedIn" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a
                    href="https://www.youtube.com/c/ISBMUniversity"
                    target="_blank"
                    aria-label="YouTube"
                    className="social-icon"
                  >
                    <img src={youtube} alt="YouTube" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="footer-copyright">
        <div className="container-xxl">
          <Row className="m-0">
            <Col className="text-center">
              <p className="fw-medium">
                © Copyright {new Date().getFullYear()}{" "}
                <a href="https://isbmuniversity.edu.in/" target="_blank">ISBM University</a>.
                All Rights Reserved
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Footer;
